import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const $ = window.jQuery;

const MainNav = {
	init() {
		const button = document.querySelector('[data-menu-toggle]');
		const close = document.querySelector('[data-menu-close]');
		if (!button) return;

		const menu = document.querySelector('[data-main-menu]');
		if (!menu) return;

		const overlay = document.querySelector('[data-menu-overlay]');
		// Om du har en overlay i HTML

		// Submenyknappar
		const toggleSubMenuBtn = $('.toggle-button');
		toggleSubMenuBtn.each(function () {
			// Sätt startvärde på aria-expanded
			$(this).attr('aria-expanded', 'false');
		});

		// Klick på submeny-knapp
		toggleSubMenuBtn.on('click', function (e) {
			e.preventDefault();
			const $btn = $(this);
			const isExpanded = $btn.attr('aria-expanded') === 'true';
			$btn.attr('aria-expanded', !isExpanded);
			$btn.parent().toggleClass('menu-collapsed');
			$btn.toggleClass('tgl-active');
		});

		// Öppna menyn (hamburgarknapp)
		button.addEventListener('click', () => {
			this.toggleMenu(button, close, menu, overlay);
			$('body').toggleClass('has-modal-open');
		});

		// Stäng menyn (close-knapp)
		if (close) {
			close.addEventListener('click', () => {
				this.toggleMenu(button, close, menu, overlay);
				$('body').toggleClass('has-modal-open');
			});
		}

		// Klick utanför menyn
		window.addEventListener('click', (e) => {
			const isOpen = menu.classList.contains('-open');
			if (isOpen) {
				// Om klicket sker varken i menyn eller på knappen/close
				if (!menu.contains(e.target) && !button.contains(e.target) && !close?.contains(e.target)) {
					this.closeMenu(button, close, menu, overlay);
				}
			}
		});

		// Stäng på Escape
		window.addEventListener('keydown', (e) => {
			const isOpen = menu.classList.contains('-open');
			if (isOpen && e.key === 'Escape') {
				this.closeMenu(button, close, menu, overlay);
			}
		});
	},

	toggleMenu(button, close, menu, overlay) {
		const isOpen = menu.classList.contains('-open');
		if (!isOpen) {
			// Öppna
			button.classList.add('-menu-open');
			close?.classList.add('-menu-open');
			menu.classList.add('-open');
			overlay?.classList.add('-active');

			// A11y
			button.setAttribute('aria-expanded', 'true');
			menu.setAttribute('aria-hidden', 'false');
			if (overlay) overlay.setAttribute('aria-hidden', 'false');

			// Body scroll
			disableBodyScroll(menu);

			// Sätt fokus på menyn eller första länken
			menu.focus();
			return;
		}

		// Annars stäng
		this.closeMenu(button, close, menu, overlay);
	},

	closeMenu(button, close, menu, overlay) {
		button.classList.remove('-menu-open');
		close?.classList.remove('-menu-open');
		menu.classList.remove('-open');
		overlay?.classList.remove('-active');

		// A11y
		button.setAttribute('aria-expanded', 'false');
		menu.setAttribute('aria-hidden', 'true');
		if (overlay) overlay.setAttribute('aria-hidden', 'true');

		// Body scroll
		enableBodyScroll(menu);

		// Återställ fokus på hamburgarknappen
		button.focus();

		$('body').removeClass('has-modal-open');
	},
};

export default MainNav;
